/**
 * Subscription plan definitions (frontend view).
 *
 * Single source of truth is `shared/plans.json` at the repo root. `plans.json`
 * in this folder is a synced copy (regenerated by `scripts/sync_plans.py`) so
 * Vite can bundle it from inside `frontend/`. Do not hand-edit `plans.json`;
 * edit `shared/plans.json` and re-run the sync script. Drift is guarded by
 * `backend/tests/test_plan_consistency.py`.
 */

import plansData from './plans.json'

export interface PlanTier {
  id: string
  name: string
  display_price: string
  period: string
  description: string
  usage_limit: number
  stripe_price_env: string | null
  trial_days: number | null
}

/** Tiers in canonical declaration order. */
export const PLAN_TIERS: PlanTier[] = plansData.tiers as PlanTier[]

/** Tier id -> plan definition. */
export const PLANS: Record<string, PlanTier> = Object.fromEntries(
  PLAN_TIERS.map((tier) => [tier.id, tier]),
)

/** Display name for any tier id — canonical lookup, else the raw id. */
export function planName(tierId: string | null | undefined): string {
  if (!tierId) return PLANS.trial.name
  return PLANS[tierId]?.name ?? tierId
}
